// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Frequency_infos__qoZj8 {
  background-color: #FFFFFF;
  border: 1px solid #d8d8ff;
  border-radius: 12px;
  padding: 16px;
  color: #00007a;
  font-size: 16px;
  font-weight: 300;
}
.Frequency_infos__qoZj8 .Frequency_price__iwYxV {
  display: block;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}

.Frequency_toggle__QKdoB {
  background-color: #FFFFFF;
  border: 1px solid #00007a;
  border-radius: 6px;
  padding: 4px;
}
.Frequency_toggle__QKdoB li {
  width: 50%;
  height: 36px;
  display: inline-block;
  list-style-type: none;
  text-align: center;
  line-height: 36px;
  color: #00007a;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.Frequency_toggle__QKdoB li.Frequency_selected__hCFgy {
  background-color: #4343ff;
  border-radius: 4px;
  color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Frequency/Frequency.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAKJ;AAHI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAKR;;AADA;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAIJ;AAFI;EACI,UAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cCzBG;ED0BH,eAAA;EACA,yBAAA;UAAA,iBAAA;AAIR;AAFQ;EACI,yBClCD;EDmCC,kBAAA;EACA,cAAA;AAIZ","sourcesContent":["@use 'styles/colors.scss';\n\n.infos{\n    background-color: #FFFFFF;\n    border: 1px solid colors.$primary2;\n    border-radius: 12px;\n    padding: 16px;\n    color: colors.$primary8;\n    font-size: 16px;\n    font-weight: 300;\n\n    .price{\n        display: block;\n        font-size: 28px;\n        font-weight: 600;\n        margin-bottom: 10px;\n    }\n}\n\n.toggle{\n    background-color: #FFFFFF;\n    border: 1px solid colors.$primary8;\n    border-radius: 6px;\n    padding: 4px;\n\n    li{\n        width: 50%;\n        height: 36px;\n        display: inline-block;\n        list-style-type: none;\n        text-align: center;\n        line-height: 36px;\n        color: colors.$primary8;\n        cursor: pointer;\n        user-select: none;\n\n        &.selected{\n            background-color: colors.$primary4;\n            border-radius: 4px;\n            color: #FFFFFF;\n        }\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"infos": `Frequency_infos__qoZj8`,
	"price": `Frequency_price__iwYxV`,
	"toggle": `Frequency_toggle__QKdoB`,
	"selected": `Frequency_selected__hCFgy`
};
export default ___CSS_LOADER_EXPORT___;
